module.exports = __webpack_public_path__ + "static/014-0e36b1cba1a4a49b226644b7945f00a0.jpg";